export const IDV_AUTH_HOLD_HOURS = 24;

export const IDV_AUTH_HOLD_HOURS_LABEL = `${IDV_AUTH_HOLD_HOURS} hours`;

export const IDV_COMPLETION_DEADLINE_HOURS_LABEL = '48 hours';
